(function () {
  /* ── Fuzzy-Suche (4.3): client-seitiger Index + Matcher ──────────────── */
  /* Die Ergebnisseite (main-search) rendert bisher nur Produkte – deshalb hier
     bewusst nur "product". Kategorien/Seiten/Ratgeber werden im Vorschlagspanel
     direkt verlinkt und brauchen den Umweg ueber die Ergebnisseite nicht. */
  var SEARCH_TYPES = 'product';
  /* Reihenfolge und Beschriftung der Gruppen im Vorschlagspanel */
  /* 30.09.2026 Mehrsprachigkeit: Beschriftungen aus den Locale-Dateien (window.btT, snippets/bt-i18n-js) */
  var tr = function (k, fb) { return window.btT ? window.btT(k, fb) : fb; };
  var FZ_GROUPS = [
    { ty: 'p', label: tr('cdx_header.group_products', 'Produkte') },
    { ty: 'c', label: tr('cdx_header.group_collections', 'Kategorien') },
    { ty: 'a', label: tr('cdx_header.group_articles', 'Ratgeber & Blog') },
    { ty: 'g', label: tr('cdx_header.group_pages', 'Seiten') }
  ];
  var FZ = { index: null };
  function fzNorm(s) {
    return (s == null ? '' : '' + s).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function fzBuild() {
    if (FZ.index) return FZ.index;
    var el = document.getElementById('cdx-search-index');
    if (!el) return null;
    return fzPrepare(el.textContent);
  }
  function fzPrepare(json) {
    var arr;
    try { arr = JSON.parse(json || '[]'); } catch (e) { return null; }
    if (!arr || !arr.length) return null;
    for (var i = 0; i < arr.length; i++) {
      var it = arr[i];
      it._t = fzNorm(it.t); it._tt = it._t ? it._t.split(' ') : [];
      it._k = fzNorm(it.k || ''); it._kt = it._k ? it._k.split(' ') : [];
    }
    FZ.index = arr;
    return arr;
  }
  /* Codext 07.10.2026 (Performance): Der Index steht nicht mehr inline im Header (100 KB
     auf jeder Seite), sondern kommt aus sections/cdx-search-index.liquid — beim ersten
     Fokus ins Suchfeld bzw. beim Zeigen darauf. Fuer die Sitzung im sessionStorage, damit
     er beim naechsten Seitenaufruf nicht erneut geladen wird. Bis er da ist, liefert die
     native Predictive-Search allein die Vorschlaege (wie bisher bei leerem Index). */
  function fzLoad(url) {
    if (FZ.index || FZ.loading || !url) return;
    FZ.loading = true;
    var key = 'cdx_fz:' + url;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && cached.t && Date.now() - cached.t < 30 * 60 * 1000 && fzPrepare(cached.d)) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /<script[^>]*id="cdx-search-index"[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
        if (!m || !fzPrepare(m[1])) { FZ.loading = false; return; }
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: m[1] })); } catch (e) {}
      })
      .catch(function () { FZ.loading = false; });
  }
  function fzLev(a, b) {
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    if (Math.abs(m - n) > 2) return 3;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      }
      for (j = 0; j <= n; j++) prev[j] = cur[j];
    }
    return prev[n];
  }
  function fzTokenScore(q, t) {
    if (t === q) return 1;
    if (t.indexOf(q) === 0) return 0.9;
    if (t.indexOf(q) >= 0) return 0.72;
    if (q.length >= 3) {
      var d = fzLev(q, t);
      var max = q.length <= 4 ? 1 : 2;
      if (d <= max) return 0.66 * (1 - d / Math.max(q.length, t.length));
    }
    return 0;
  }
  function fzBest(qtok, toks) {
    var best = 0;
    for (var i = 0; i < toks.length; i++) {
      var s = fzTokenScore(qtok, toks[i]);
      if (s > best) { best = s; if (best === 1) break; }
    }
    return best;
  }
  function fzScore(item, qTokens) {
    var total = 0;
    for (var i = 0; i < qTokens.length; i++) {
      var st = fzBest(qTokens[i], item._tt);
      var sk = fzBest(qTokens[i], item._kt) * 0.6;
      var best = st > sk ? st : sk;
      if (best === 0) return 0;
      total += best;
    }
    return total / qTokens.length;
  }
  function fzEsc(s) {
    return (s == null ? '' : '' + s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fzResultsHtml(rawTerm, correctedTerm, searchUrl, limit) {
    var idx = fzBuild();
    if (!idx) return null;
    var qn = fzNorm(correctedTerm || rawTerm);
    var qTokens = qn ? qn.split(' ') : [];
    if (!qTokens.length) return '';
    var scored = [];
    for (var i = 0; i < idx.length; i++) {
      var s = fzScore(idx[i], qTokens);
      if (s >= 0.45) scored.push({ it: idx[i], s: s });
    }
    if (!scored.length) return '';
    scored.sort(function (a, b) { return b.s - a.s; });

    function card(it) {
      var img = it.i ? '<div class="search-bar__image-container"><div class="aspect-ratio aspect-ratio--square"><img src="' + fzEsc(it.i) + '" alt="' + fzEsc(it.t) + '" loading="lazy"></div></div>' : '';
      return '<a href="' + fzEsc(it.u) + '" class="search-bar__result-item">' + img +
        '<div class="search-bar__item-info"><p class="search-bar__item-title">' + fzEsc(it.t) + '</p>' +
        '<span class="search-bar__item-price">' + fzEsc(it.pr) + '</span></div></a>';
    }
    function row(it) {
      return '<li><a href="' + fzEsc(it.u) + '" class="search-bar__result-link">' + fzEsc(it.t) +
        (it.pr ? '<span class="cdx-sp-count">' + fzEsc(it.pr) + '</span>' : '') + '</a></li>';
    }

    /* Produkte bekommen das Karten-Budget, die uebrigen Gruppen je bis zu 4 Zeilen –
       so bleiben Kategorien/Ratgeber/Seiten auch bei vielen Produkttreffern sichtbar. */
    var html = '';
    for (var g = 0; g < FZ_GROUPS.length; g++) {
      var grp = FZ_GROUPS[g];
      var hits = scored.filter(function (r) { return (r.it.ty || 'p') === grp.ty; });
      if (!hits.length) continue;
      html += '<p class="search-bar__result-category">' + grp.label + '</p>';
      if (grp.ty === 'p') {
        html += '<div class="search-bar__result-products">' +
          hits.slice(0, limit || 6).map(function (r) { return card(r.it); }).join('') + '</div>';
      } else {
        html += '<ul class="search-bar__result-linklist list--unstyled" role="list">' +
          hits.slice(0, 4).map(function (r) { return row(r.it); }).join('') + '</ul>';
      }
    }
    var url = (searchUrl || '/search') + '?q=' + encodeURIComponent(rawTerm) + '&type=' + SEARCH_TYPES;
    return html + '<a class="search-bar__view-all" href="' + url + '">' + tr('cdx_header.view_all_results', 'Alle Ergebnisse ansehen') + '</a>';
  }

  /* ── Menue-Piktogramme nachladen (Codext 07.10.2026, Performance) ────────
     Der Header rendert nur Platzhalter (snippets/cdx-nav-icon, lazy) - die
     Metafeld-Abfrage je Menue-Objekt kostete ungecacht 150 bis 300 ms
     Renderzeit pro Seite. Die Liste URL -> Bild kommt aus
     sections/cdx-nav-icons (fuer alle Besucher gleich, von Shopify gecacht),
     geladen im Leerlauf nach dem Seitenaufbau oder beim ersten Zeigen auf den
     Header, und bleibt fuer die Sitzung im sessionStorage. Eintraege ohne
     Piktogramm bleiben wie bisher ohne. */
  var NI = { map: null, loading: false };
  function navIconsApply(map) {
    var els = document.querySelectorAll('[data-nav-icon]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var src = map[el.getAttribute('data-nav-icon')];
      if (!src) continue;
      el.style.setProperty('--cdx-nav-img', "url('" + String(src).replace(/'/g, '%27') + "')");
      el.classList.remove('cdx-nav-lazy');
      var pk = el.parentElement;
      if (pk && pk.classList.contains('cdx-pk')) pk.classList.remove('cdx-nav-lazy');
      el.removeAttribute('data-nav-icon');
    }
  }
  function navIconsLoad(url) {
    if (NI.map || NI.loading) return;
    NI.loading = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /<script[^>]*id="cdx-nav-icons"[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
        var map = null;
        try { map = m ? JSON.parse(m[1]) : null; } catch (e) {}
        if (!map) { NI.loading = false; return; }
        NI.map = map;
        navIconsApply(map);
        try { sessionStorage.setItem('cdx_ni:' + url, JSON.stringify({ t: Date.now(), m: map })); } catch (e) {}
      })
      .catch(function () { NI.loading = false; });
  }
  function navIconsInit(root, url) {
    if (!NI.map) {
      try {
        var c = JSON.parse(sessionStorage.getItem('cdx_ni:' + url) || 'null');
        if (c && c.m && Date.now() - c.t < 30 * 60 * 1000) NI.map = c.m;
      } catch (e) {}
    }
    if (NI.map) { navIconsApply(NI.map); return; }
    var go = function () { navIconsLoad(url); };
    var idle = function () { if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 300); };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
    root.addEventListener('pointerover', go, { once: true, passive: true });
    root.addEventListener('focusin', go, { once: true });
  }

  function init(root) {
    if (!root || root.__cdxInit) return;
    root.__cdxInit = true;
    var niUrl = root.getAttribute('data-nav-icons-url');
    if (niUrl) navIconsInit(root, niUrl);

    var cfg = {
      sticky: root.getAttribute('data-sticky') === 'true',
      stickyOffset: parseInt(root.getAttribute('data-sticky-offset') || '80', 10),
      megaTrigger: root.getAttribute('data-mega-trigger') || 'hover',
      hoverDelay: parseInt(root.getAttribute('data-hover-delay') || '150', 10),
      tickerInterval: parseInt(root.getAttribute('data-ticker-interval') || '5000', 10),
      predictiveUrl: root.getAttribute('data-predictive-url') || '/search/suggest',
      predictiveSection: root.getAttribute('data-predictive-section') || 'predictive-search',
      searchUrl: root.getAttribute('data-search-url') || '/search',
      openDays: (root.getAttribute('data-open-days') || '1,2,3,4,5').split(',').map(Number),
      openStart: parseInt(root.getAttribute('data-open-start') || '480', 10),
      openEnd: parseInt(root.getAttribute('data-open-end') || '990', 10)
    };

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* Suchindex nachladen, sobald jemand Richtung Suche geht (siehe fzLoad) */
    var fzUrl = root.getAttribute('data-search-index-url');
    if (fzUrl) {
      var fzWant = function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('input[type="search"], .cdx-hd__search, [data-action*="search"]')) fzLoad(fzUrl);
      };
      document.addEventListener('focusin', fzWant);
      document.addEventListener('pointerover', fzWant, { passive: true });
      document.addEventListener('pointerdown', fzWant, { passive: true });
    }

    function applyHours() {
      /* Test-Override: localStorage.bt_hours_force = 'open' | 'closed' (entfernen = normal) */
      var open, force = null;
      try { force = localStorage.getItem('bt_hours_force'); } catch (e) {}
      if (force === 'open' || force === 'closed') {
        open = force === 'open';
      } else {
        var n = new Date(), d = n.getDay(), m = n.getHours() * 60 + n.getMinutes();
        open = cfg.openDays.indexOf(d) !== -1 && m >= cfg.openStart && m <= cfg.openEnd;
      }
      $$('[data-bt-status]').forEach(function (s) {
        s.classList.toggle('is-closed', !open);
        var t = s.querySelector('[data-bt-status-txt]');
        if (t) t.textContent = open ? (s.getAttribute('data-open-label') || t.textContent)
                                    : (s.getAttribute('data-closed-label') || tr('cdx_header.closed_now', 'Gerade geschlossen'));
      });
      /* dokumentweit, damit auch Elemente ausserhalb des Headers (z. B. PDP-Beratungsbanner) mitschalten */
      $$('[data-bt-phone]', document).forEach(function (p) { p.hidden = !open; });
      $$('[data-bt-callback]', document).forEach(function (c) { c.hidden = open; });
      $$('[data-bt-open]', document).forEach(function (e) { e.hidden = !open; });
      $$('[data-bt-closed]', document).forEach(function (e) { e.hidden = open; });
    }
    applyHours();
    setInterval(applyHours, 60000);

    if (cfg.sticky) {
      var spacer = document.createElement('div');
      spacer.className = 'cdx-hd__spacer';
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.height = '0px';
      if (root.parentNode) root.parentNode.insertBefore(spacer, root.nextSibling);
      var stuckFixed = false, startY = 0;
      var updateSticky = function () {
        var y = window.pageYOffset;
        if (!stuckFixed) startY = root.getBoundingClientRect().top + y;
        var shouldFix = y > startY;
        if (shouldFix && !stuckFixed) {
          spacer.style.height = root.offsetHeight + 'px';
          root.classList.add('is-fixed');
          stuckFixed = true;
        } else if (!shouldFix && stuckFixed) {
          root.classList.remove('is-fixed');
          spacer.style.height = '0px';
          stuckFixed = false;
        }
        if (stuckFixed) spacer.style.height = root.offsetHeight + 'px';
        root.classList.toggle('is-stuck', y > cfg.stickyOffset);
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    /* Mega-Menü beim Seiten-Scroll schließen (interner Mega-Scroll bleibt, dank overscroll-behavior) */
    var megaScrollTick = false;
    window.addEventListener('scroll', function () {
      if (megaScrollTick || !activeItem) return;
      megaScrollTick = true;
      requestAnimationFrame(function () { megaScrollTick = false; closeMega(); });
    }, { passive: true });

    var scrim = $('.cdx-hd__scrim');
    function setPanelOpen(on) { root.classList.toggle('is-panel-open', on); }
    if (scrim) scrim.addEventListener('click', closeAll);

    var openTimer = null, closeTimer = null, activeItem = null;

    /* Hover-Timer: Es gibt immer hoechstens EINEN Oeffnen- und EINEN Schliessen-Timer.
       Frueher wurde closeTimer bei jedem mouseleave ueberschrieben, ohne den alten zu
       loeschen – beim Ueberstreichen von drei Punkten schloss der verwaiste Timer das
       gerade geoeffnete Mega wieder, und ohne neues mouseenter blieb es zu. */
    function scheduleOpen(item) {
      clearTimeout(closeTimer); closeTimer = null;
      if (activeItem === item) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openTimer = null; openMega(item); }, cfg.hoverDelay);
    }
    function scheduleClose() {
      clearTimeout(openTimer); openTimer = null;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeTimer = null;
        /* Vor dem Schliessen nachsehen, wo der Zeiger wirklich steht (:hover ist die
           Wahrheit, nicht die Reihenfolge der Events). */
        var over = $('.cdx-hd__nav-item.has-mega:hover');
        if (over) { if (over !== activeItem) openMega(over); return; }
        if ($('.cdx-hd__mega.is-open:hover')) return;
        closeMega();
      }, 180);
    }

    function megaFor(item) {
      var id = item.getAttribute('data-mega');
      return id ? $('.cdx-hd__mega[data-mega="' + id + '"]') : null;
    }
    function openMega(item) {
      clearTimeout(closeTimer);
      if (activeItem === item) return;
      closeSearch();
      closeMega();
      var mega = megaFor(item);
      if (!mega) return;
      item.classList.add('is-active');
      item.setAttribute('aria-expanded', 'true');
      mega.classList.add('is-open');
      if (mega.getAttribute('data-mega') === 'service' && main && root.classList.contains('cdx-hd--nr-up')) {
        var _op = mega.offsetParent || root;
        mega.style.top = (main.getBoundingClientRect().bottom - _op.getBoundingClientRect().top) + 'px';
      } else {
        mega.style.top = '';
      }
      activeItem = item;
      setPanelOpen(true);
    }
    function closeMega() {
      if (activeItem) {
        activeItem.classList.remove('is-active');
        activeItem.setAttribute('aria-expanded', 'false');
        var m = megaFor(activeItem);
        if (m) { m.classList.remove('is-open'); m.style.top = ''; }
        activeItem = null;
      }
      if (!searchOpen()) setPanelOpen(false);
    }

    $$('.cdx-hd__nav-item.has-mega').forEach(function (item) {
      /* Hauptpunkte mit echtem Ziel sind <a> (Kategorieseite), der Rest bleibt <button>. */
      var isLink = item.tagName === 'A' && item.getAttribute('href');
      if (cfg.megaTrigger === 'click') {
        item.addEventListener('click', function (e) {
          /* Link-Items: 1. Klick oeffnet das Mega, 2. Klick folgt dem Link. */
          if (isLink && activeItem === item) return;
          e.preventDefault();
          (activeItem === item) ? closeMega() : openMega(item);
        });
      } else {
        item.addEventListener('mouseenter', function () { scheduleOpen(item); });
        /* Nachholen, wenn kein mouseenter mehr kommt: nach dem Schliessen per Scroll
           steht der Zeiger noch auf dem Punkt, und beim schnellen Ueberstreichen
           mehrerer Punkte kann ein Schliessen dazwischenfunken (s. scheduleClose). */
        item.addEventListener('mousemove', function () {
          if (activeItem !== item && !openTimer) scheduleOpen(item);
        });
        item.addEventListener('mouseleave', scheduleClose);
        item.addEventListener('click', function (e) {
          if (isLink) return; /* Klick navigiert, Hover hat das Mega schon geoeffnet */
          e.preventDefault();
          openMega(item);
        });
      }
      /* Tastatur: Fokus oeffnet das Mega, damit die Spalten per Tab erreichbar sind. */
      item.addEventListener('focus', function () { openMega(item); });
    });
    $$('.cdx-hd__mega').forEach(function (mega) {
      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); closeTimer = null; });
      mega.addEventListener('mouseleave', function () {
        if (cfg.megaTrigger === 'hover') scheduleClose();
      });
    });

    var main = $('.cdx-hd__main');
    var searchEl = $('.cdx-hd__search');
    var searchPane = $('.cdx-hd__search-pane');
    var searchInput = main ? main.querySelector('.cdx-hd__search input[type="search"]') : null;
    var liveBox = searchPane ? searchPane.querySelector('.cdx-hd__sp-live') : null;
    function searchOpen() { return main && main.classList.contains('is-search-focused'); }
    function openSearch() {
      if (!main || searchOpen()) return;
      closeMega();
      main.classList.add('is-search-focused');
      setPanelOpen(true);
      lockBody(true);
      sizeLive(searchPane);
      /* stehenden Begriff wiederherstellen (sonst Default-Grid trotz Text im Feld) */
      if (searchInput && searchInput.value.trim().length >= 2) {
        renderPredictive(searchInput.value.trim(), searchPane, '.cdx-hd__sp-live', 'is-live');
      }
    }
    function closeSearch() {
      if (!main || !searchOpen()) return;
      main.classList.remove('is-search-focused');
      if (searchPane) searchPane.classList.remove('is-live');
      if (!activeItem) setPanelOpen(false);
      lockBody(false);
    }
    if (searchInput) {
      searchInput.addEventListener('focus', openSearch);
      /* 27.10.2026: Nach Escape oder einem Klick, der den Fokus nicht wegnimmt,
         steht der Cursor noch im Feld - erneutes Reinklicken loest dann kein
         focus aus, und die Treffer liefen ins geschlossene Panel. Deshalb oeffnen
         auch Klick und Eingabe; openSearch rendert den aktuellen Begriff selbst. */
      searchInput.addEventListener('click', openSearch);
      searchInput.addEventListener('input', function () {
        if (!searchOpen()) { openSearch(); return; }
        renderPredictive(searchInput.value.trim(), searchPane, '.cdx-hd__sp-live', 'is-live');
      });
    }
    window.addEventListener('resize', function () { if (searchOpen()) sizeLive(searchPane); });

    var predTimer = null, predCache = {}, predSeq = 0;
    /* Baut aus „eingabe = ziel"-Zeilen einen Ein-Pass-Ersetzer:
       - eine kombinierte Regex, längste Schlüssel zuerst (kein Teiltreffer)
       - Wortgrenzen inkl. Umlauten/ß (JS-\b kennt die nicht), ohne Lookbehind (Browser-Kompat)
       - ein Durchlauf → keine Ketten-Ersetzung (drogentresor→btm-tresor bleibt btm-tresor) */
    function parseSynonyms(raw) {
      var map = {}, keys = [];
      if (!raw) return null;
      raw.split(/\r?\n/).forEach(function (line) {
        var i = line.indexOf('=');
        if (i < 1) return;
        var key = line.slice(0, i).trim().toLowerCase();
        var val = line.slice(i + 1).trim();
        if (!key || !val || map[key] != null) return;
        map[key] = val; keys.push(key);
      });
      if (!keys.length) return null;
      keys.sort(function (a, b) { return b.length - a.length; });
      var esc = keys.map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      try {
        return { map: map, re: new RegExp('(^|[^a-z0-9äöüß])(' + esc.join('|') + ')(?![a-z0-9äöüß])', 'gi') };
      } catch (e) { return null; }
    }
    var searchSyn = parseSynonyms(root.getAttribute('data-search-synonyms'));
    function correctTerm(term) {
      if (!searchSyn) return term;
      return term.replace(searchSyn.re, function (m, pre, kw) {
        var v = searchSyn.map[kw.toLowerCase()];
        return pre + (v != null ? v : kw);
      });
    }
    /* Trefferliste scrollt, der „Alle Ergebnisse“-CTA bleibt darunter stehen –
       sonst liegt er ausserhalb der max-height und das Panel wirkt abgeschnitten.
       Der native Predictive-Button ist ausserdem type=submit, steht aber ausserhalb
       des Formulars: hier wird er zu einem echten Link auf die Suchergebnisseite. */
    function layoutLive(live, term) {
      if (!live || live.querySelector(':scope > .cdx-sp-scroll')) return;
      var cta = live.querySelector('.search-bar__view-all');
      var scroll = document.createElement('div');
      scroll.className = 'cdx-sp-scroll';
      while (live.firstChild) scroll.appendChild(live.firstChild);
      live.appendChild(scroll);
      if (!cta) return;
      if (cta.tagName === 'BUTTON') {
        var a = document.createElement('a');
        a.className = cta.className;
        a.href = cfg.searchUrl + '?q=' + encodeURIComponent(term) + '&type=' + SEARCH_TYPES;
        a.innerHTML = cta.innerHTML;
        cta.parentNode.replaceChild(a, cta);
        cta = a;
      }
      var foot = document.createElement('div');
      foot.className = 'cdx-sp-cta';
      foot.appendChild(cta);
      live.appendChild(foot);
    }
    /* Maximalhoehe = tatsaechlich freier Platz unter dem Panel-Kopf (Topbar kann
       beim Sticky-Scroll wegfallen), damit nie unten aus dem Viewport gelaufen wird. */
    function sizeLive(container) {
      if (!container || !container.classList.contains('cdx-hd__search-pane')) return;
      var top = container.getBoundingClientRect().top;
      var avail = Math.max(240, window.innerHeight - top - 20);
      container.style.setProperty('--cdx-sp-max', avail + 'px');
    }
    function applyPredictive(container, live, out, term) {
      if (!live) return;
      var empty = !out || /search-bar__empty-state/.test(out) || !/search-bar__result-(item|link)/.test(out);
      if (empty) {
        var tpl = container.querySelector('[data-noresults]');
        if (tpl) {
          live.innerHTML = tpl.innerHTML;
          var t = live.querySelector('[data-term]');
          if (t) t.textContent = '„' + term + '"';
          var cb = live.querySelector('[data-action="open-contact"]');
          if (cb) cb.addEventListener('click', function (e) { e.preventDefault(); openContact(); });
        } else {
          live.innerHTML = out || '';
        }
      } else {
        live.innerHTML = out;
      }
      layoutLive(live, term);
      sizeLive(container);
      live.removeAttribute('aria-busy');
    }
    function renderPredictive(term, container, liveSel, liveClass) {
      if (!container) return;
      var live = container.querySelector(liveSel);
      if (term.length < 2) { container.classList.remove(liveClass); return; }
      container.classList.add(liveClass);
      var q = correctTerm(term);
      var seq = ++predSeq;

      /* Der lokale Index kennt nur die ersten 50 Produkte (Liquid-Limit) und keine
         Kategorien/Ratgeber vom Server – er liefert deshalb nur das Sofortbild.
         Massgeblich ist danach immer die native Predictive-Search ueber den ganzen
         Katalog; nur wenn die leer ausgeht (klassischer Tippfehler), bleibt der
         Fuzzy-Treffer stehen. */
      var fz = fzResultsHtml(term, q, cfg.searchUrl, 8);
      var hasFz = !!fz;
      if (hasFz) applyPredictive(container, live, fz, term);
      if (live) live.setAttribute('aria-busy', 'true');

      clearTimeout(predTimer);
      predTimer = setTimeout(function () {
        function done(out) {
          if (seq !== predSeq) return; /* zwischenzeitlich weitergetippt */
          var nativeEmpty = !out || !/search-bar__result-(item|link)/.test(out);
          if (nativeEmpty && hasFz) { if (live) live.removeAttribute('aria-busy'); return; }
          applyPredictive(container, live, out, term);
        }
        if (predCache[q] != null) { done(predCache[q]); return; }
        var url = cfg.predictiveUrl + '?q=' + encodeURIComponent(q)
                + '&resources[type]=product,query,collection,page,article'
                + '&resources[limit]=8&section_id=' + cfg.predictiveSection;
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('.search-ajax') || doc.body;
            var out = node ? node.innerHTML : '';
            predCache[q] = out;
            done(out);
          })
          .catch(function () { if (live) live.removeAttribute('aria-busy'); });
      }, 200);
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { closeMega(); closeSearch(); }
      if (searchEl && !searchEl.contains(e.target) && searchOpen()) closeSearch();
      if (cartIsOpen && miniCart && !miniCart.contains(e.target) && !e.target.closest('[data-action="toggle-mini-cart"]')) closeCart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); }
    });
    function closeAll() {
      closeMega(); closeSearch();
      closeDrawer(); closeMobSearch(); closeCart(); closeContact(); closeService();
    }

    $$('[data-mb-tick]').forEach(function (t) {
      var slides = $$('.cdx-hd__mb-slide', t);
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, cfg.tickerInterval);
    });

    var drawer = $('.cdx-hd__drawer-host');
    function openDrawer() { if (drawer) { drawer.classList.add('is-open'); lockBody(true); } }
    function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); lockBody(false); } }
    $$('[data-action="open-drawer"]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    if (drawer) {
      $$('[data-action="close-drawer"]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
      var dscrim = drawer.querySelector('.cdx-hd__drawer-scrim');
      if (dscrim) dscrim.addEventListener('click', closeDrawer);
      $$('.cdx-hd__acc', drawer).forEach(function (acc) {
        acc.addEventListener('click', function () { acc.classList.toggle('is-open'); });
      });
    }

    /* Kontakt-Popup „Nachricht senden" (1.1) */
    var contactHost = $('[data-contact-host]');
    function openContact() {
      if (!contactHost) return;
      closeMega(); closeSearch(); closeDrawer(); closeMobSearch(); closeService();
      var u = contactHost.querySelector('[data-contact-url]');
      var t = contactHost.querySelector('[data-contact-title]');
      var r = contactHost.querySelector('[data-contact-ref]');
      if (u) u.value = window.location.href;
      if (t) t.value = document.title;
      if (r) r.value = document.referrer || '';
      contactHost.classList.add('is-open');
      contactHost.setAttribute('aria-hidden', 'false');
      lockBody(true);
      var first = contactHost.querySelector('input:not([type=hidden]):not([tabindex="-1"]),textarea');
      if (first) setTimeout(function () { first.focus(); }, 80);
    }
    function closeContact() {
      if (!contactHost || !contactHost.classList.contains('is-open')) return;
      contactHost.classList.remove('is-open');
      contactHost.setAttribute('aria-hidden', 'true');
      lockBody(false);
    }
    /* Dokumentweit binden (Befund BT 31.08. und 04.09.2026): $$ sucht per
       Definition nur innerhalb von root, also im Header. Ausloeser ausserhalb
       des Headers, etwa in der PDP-Beratungsbox, bekamen sonst keinen Listener.
       Die Sperre verhindert Doppelbindung, wenn init je Header-Instanz laeuft. */
    $$('[data-action="open-contact"]', document).forEach(function (b) {
      if (b.__cdxContactBound) return;
      b.__cdxContactBound = true;
      b.addEventListener('click', function (e) { e.preventDefault(); openContact(); });
    });
    if (contactHost) {
      $$('[data-action="close-contact"]', contactHost).forEach(function (b) { b.addEventListener('click', closeContact); });
      var cForm = contactHost.querySelector('.cdx-hd__contact-form');
      if (cForm) cForm.addEventListener('submit', function (e) {
        var hp = cForm.querySelector('[data-hp]');
        if (hp && hp.value) { e.preventDefault(); return; }
        /* Debug-Modus: localStorage.cdx_contact_debug='1' → zeigt Übermittlung & blockt echten Versand */
        var dbg = false;
        try { dbg = !!localStorage.getItem('cdx_contact_debug'); } catch (err) {}
        if (dbg) {
          e.preventDefault();
          var data = {};
          new FormData(cForm).forEach(function (v, k) { data[k] = v; });
          console.group('%c[cdx] Kontaktformular – DEBUG (nicht gesendet)', 'color:#0B1C5E;font-weight:700');
          console.log('Ziel (action):', cForm.action);
          console.table(data);
          console.info("Deaktivieren: localStorage.removeItem('cdx_contact_debug')");
          console.groupEnd();
        }
      });
      /* nach Absenden (Erfolg oder Fehler) Popup wieder öffnen */
      if (contactHost.querySelector('[data-contact-success],[data-contact-err]')) openContact();
    }

    /* Kundenservice-Popup (2.2) */
    var serviceHost = $('[data-service-host]');
    function openService() {
      if (!serviceHost) return;
      closeMega(); closeSearch(); closeDrawer(); closeMobSearch(); closeContact();
      svcMountForms();
      serviceHost.classList.add('is-open');
      serviceHost.setAttribute('aria-hidden', 'false');
      lockBody(true);
    }
    function closeService() {
      if (!serviceHost || !serviceHost.classList.contains('is-open')) return;
      serviceHost.classList.remove('is-open');
      serviceHost.setAttribute('aria-hidden', 'true');
      lockBody(false);
      svcReset();
    }
    /* Naechste Seite im Popup (09.09.2026): die Kacheln Geschaeftskunde und
       Jungjaeger blenden die Hauptansicht aus und eine Unterseite mit dem
       Shopify-Forms-Formular ein. Zurueck ueber den Knopf oben, beim Schliessen
       wird immer auf die Hauptansicht zurueckgesetzt. */
    var svcMain = serviceHost ? serviceHost.querySelector('[data-svc-main]') : null;
    var svcPages = serviceHost ? $$('[data-svc-page-panel]', serviceHost) : [];
    /* Die Shopify-Forms-Bloecke liegen in sections/cdx-service-forms (Header-
       Gruppe), weil die Header-Section keine @app-Bloecke aufnehmen darf. Beim
       ersten Oeffnen werden sie in die Slots der Unterseiten VERSCHOBEN, nicht
       kopiert, damit die Skripte der App an ihren Knoten bleiben. */
    function svcMountForms() {
      if (!serviceHost) return;
      var neu = [];
      $$('[data-svc-form-slot]', serviceHost).forEach(function (slot) {
        if (slot.getAttribute('data-svc-mounted')) return;
        var key = slot.getAttribute('data-svc-form-slot');
        var src = document.querySelector('[data-cdx-svc-forms] [data-svc-form="' + key + '"]');
        if (!src || !src.firstElementChild) return;
        /* Codext 07.10.2026: Bloecke liegen als <template> vor (sections/cdx-service-forms),
           damit hCaptcha nicht schon beim Seitenaufruf laedt. Eingefuegte Inline-Skripte
           aus dem Template laufen beim Einfuegen. */
        var tpl = src.querySelector('template[data-svc-form-tpl]');
        if (tpl) {
          slot.appendChild(document.importNode(tpl.content, true));
          neu.push(slot);
        } else {
          while (src.firstChild) slot.appendChild(src.firstChild);
        }
        slot.setAttribute('data-svc-mounted', '1');
        var fb = serviceHost.querySelector('[data-svc-form-fallback="' + key + '"]');
        if (fb) fb.hidden = true;
      });
      if (neu.length) svcFormsStart(neu);
    }
    /* Das Forms-Skript der App (…/forms-<version>/assets/index.js, ein Modul) baut nur
       die Formular-Container auf, die bei seinem Lauf im DOM stehen, und beobachtet das
       DOM nicht. Fuer die erst jetzt eingesetzten Container wird es deshalb ein zweites
       Mal ausgefuehrt: ein Modul-Script mit Fragment ergibt einen eigenen Moduleintrag, die Datei
       kommt aus dem Browser-Cache. Bereits aufgebaute Container anderer Formulare werden
       fuer diesen Lauf versteckt, sonst entstuenden sie doppelt. Klappt es nicht, kommt
       der bisherige Ersatz-Button zurueck. */
    function svcFormsStart(slots) {
      var roots = [];
      slots.forEach(function (slot) {
        var r = slot.querySelector('[data-form-root]');
        if (r) roots.push(r);
      });
      function fallback() {
        slots.forEach(function (slot) {
          var r = slot.querySelector('[data-form-root]');
          if (r && r.querySelector('shopify-forms-embed')) return;
          var fb = serviceHost.querySelector('[data-svc-form-fallback="' + slot.getAttribute('data-svc-form-slot') + '"]');
          if (fb) fb.hidden = false;
        });
      }
      function run() {
        var offen = roots.filter(function (r) { return !r.querySelector('shopify-forms-embed'); });
        if (!offen.length) return;
        var url = null;
        $$('script[src]', document).some(function (s) {
          if (/\/forms-[^/]+\/assets\/index\.js(\?|$)/.test(s.src)) { url = s.src; return true; }
          return false;
        });
        if (!url) { fallback(); return; }
        var andere = $$('[data-form-root]', document).filter(function (r) { return roots.indexOf(r) < 0; });
        andere.forEach(function (r) { r.removeAttribute('data-form-root'); });
        var zurueck = function () {
          andere.forEach(function (r) { r.setAttribute('data-form-root', 'true'); });
        };
        var t = setTimeout(fallback, 8000);
        /* Bewusst ein <script type="module"> statt import(): Shopify minifiziert Theme-JS
           mit esbuild und macht aus import() ein require(), das im Browser fehlt. */
        var mod = document.createElement('script');
        mod.type = 'module';
        mod.src = url + '#cdx-svc';
        mod.onload = function () {
          setTimeout(function () {
            zurueck();
            if (roots.every(function (r) { return r.querySelector('shopify-forms-embed'); })) clearTimeout(t);
          }, 1500);
        };
        mod.onerror = function () { zurueck(); clearTimeout(t); fallback(); };
        document.head.appendChild(mod);
      }
      /* Ist die Seite noch nicht fertig geladen, kann der erste Lauf des Forms-Skripts
         noch ausstehen und die Container selbst aufbauen — dann erst danach pruefen. */
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }
    function svcReset() {
      if (!svcMain) return;
      svcPages.forEach(function (p) { p.hidden = true; });
      svcMain.hidden = false;
      serviceHost.classList.remove('is-page');
    }
    function svcShowPage(key) {
      if (!svcMain) return;
      var found = false;
      svcPages.forEach(function (p) {
        var on = p.getAttribute('data-svc-page-panel') === key;
        p.hidden = !on;
        if (on) found = true;
      });
      svcMain.hidden = found;
      serviceHost.classList.toggle('is-page', found);
      var panel = serviceHost.querySelector('.cdx-hd__pop-panel');
      if (panel) panel.scrollTop = 0;
      if (found) {
        var back = serviceHost.querySelector('[data-svc-page-panel="' + key + '"] [data-action="svc-back"]');
        if (back) back.focus();
      }
    }
    $$('[data-action="open-service"]', document).forEach(function (b) {
      if (b.__cdxServiceBound) return;
      b.__cdxServiceBound = true;
      b.addEventListener('click', function (e) { e.preventDefault(); openService(); });
    });
    if (serviceHost) {
      $$('[data-action="close-service"]', serviceHost).forEach(function (b) { b.addEventListener('click', closeService); });
      $$('[data-action="svc-page"]', serviceHost).forEach(function (b) {
        b.addEventListener('click', function (e) {
          var key = b.getAttribute('data-svc-page');
          e.preventDefault();
          svcMountForms();
          svcShowPage(key); /* ohne Formular zeigt die Unterseite den Registrieren-Button */
        });
      });
      $$('[data-action="svc-back"]', serviceHost).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); svcReset(); });
      });
    }

    var mob = $('.cdx-hd__mob-search');
    var mobInput = mob ? mob.querySelector('input[type="search"]') : null;
    /* readonly Anzeigefelder (Header-Persistent + Drawer), die den Begriff spiegeln */
    var mbDisplays = $$('.cdx-hd__mb-field input, .cdx-hd__drawer-search .cdx-field input');
    function setMbDisplay(v) { mbDisplays.forEach(function (el) { el.value = v; }); }
    function openMobSearch() {
      if (!mob || mob.classList.contains('is-open')) return;
      closeDrawer();
      mob.classList.add('is-open'); lockBody(true);
      renderRecent();
      if (mobInput) {
        var cur = mbDisplays[0] ? mbDisplays[0].value : '';
        if (cur) {
          mobInput.value = cur;
          mobInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        setTimeout(function () { mobInput.focus(); }, 50);
      }
    }
    function closeMobSearch() {
      if (!mob) return;
      if (mobInput) setMbDisplay(mobInput.value);
      mob.classList.remove('is-open'); lockBody(false);
    }
    $$('[data-action="open-mob-search"]').forEach(function (b) { b.addEventListener('click', openMobSearch); });
    if (mob) {
      $$('[data-action="close-mob-search"]', mob).forEach(function (b) { b.addEventListener('click', closeMobSearch); });
      if (mobInput) {
        mobInput.addEventListener('input', function () {
          setMbDisplay(mobInput.value);
          renderPredictive(mobInput.value.trim(), mob, '.cdx-hd__mob-live', 'is-live');
        });
        mobInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && mobInput.value.trim()) saveRecent(mobInput.value.trim());
        });
      }
    }

    $$('[data-search-clear]').forEach(function (btn) {
      var form = btn.closest('form');
      var inp = form ? form.querySelector('input[type="search"]') : null;
      if (!inp) return;
      function sync() { btn.hidden = !inp.value; }
      inp.addEventListener('input', sync);
      sync();
      btn.addEventListener('click', function () {
        inp.value = '';
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.focus();
        btn.hidden = true;
      });
    });

    var miniCart = $('#mini-cart');
    var cartUrl = root.getAttribute('data-cart-url') || (window.routes && window.routes.cartUrl) || '/cart';
    var cartChangeUrl = root.getAttribute('data-cart-change-url') || (window.routes && window.routes.cartChangeUrl) || '/cart/change';
    var cartIsOpen = false;
    function setCartCount(n) {
      $$('.header__cart-count').forEach(function (el) { el.textContent = n; });
      if (miniCart) miniCart.setAttribute('data-item-count', n);
    }
    function openCart() {
      if (!miniCart) return;
      closeMega(); closeSearch();
      miniCart.setAttribute('aria-hidden', 'false');
      root.classList.add('is-cart-open');
      $$('[data-action="toggle-mini-cart"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (!cartIsOpen) lockBody(true);
      cartIsOpen = true;
    }
    function closeCart() {
      if (!miniCart || !cartIsOpen) return;
      miniCart.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-cart-open');
      $$('[data-action="toggle-mini-cart"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      cartIsOpen = false;
      lockBody(false);
    }
    function toggleCart(e) { if (e) e.preventDefault(); cartIsOpen ? closeCart() : openCart(); }
    function cartRefresh(openAfter) {
      return fetch(cartUrl + '?section_id=mini-cart', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#mini-cart') || doc.querySelector('.mini-cart');
          if (fresh && miniCart) miniCart.innerHTML = fresh.innerHTML;
          if (fresh) {
            var n = parseInt(fresh.getAttribute('data-item-count') || '0', 10);
            if (!isNaN(n)) setCartCount(n);
          }
          if (openAfter) openCart();
        })
        .catch(function () {});
    }
    function changeLine(line, qty) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      return fetch(cartChangeUrl + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (c) { if (c && typeof c.item_count !== 'undefined') setCartCount(c.item_count); return cartRefresh(false); })
        .catch(function () { return cartRefresh(false); })
        .then(function () { document.dispatchEvent(new CustomEvent('theme:loading:end')); });
    }
    if (miniCart) {
      var cartScrim = $('.cdx-hd__cart-scrim');
      if (cartScrim) cartScrim.addEventListener('click', closeCart);
      $$('[data-action="toggle-mini-cart"]').forEach(function (b) { b.addEventListener('click', toggleCart); });
      miniCart.addEventListener('click', function (e) {
        if (e.target.closest('[data-action="close-mini-cart"]')) { e.preventDefault(); closeCart(); return; }
        var btn = e.target.closest('[data-action="increase-quantity"],[data-action="decrease-quantity"]');
        if (!btn) return;
        e.preventDefault();
        var line = btn.getAttribute('data-line'), qty = parseInt(btn.getAttribute('data-quantity'), 10);
        if (line && !isNaN(qty)) changeLine(line, qty);
      });
      miniCart.addEventListener('change', function (e) {
        var inp = e.target.closest('.quantity-selector__value');
        if (!inp) return;
        var line = inp.getAttribute('data-line'), qty = parseInt(inp.value, 10);
        if (line && !isNaN(qty)) changeLine(line, qty);
      });
      document.addEventListener('product:added', function () { cartRefresh(true); });
      document.addEventListener('cart:refresh', function () { cartRefresh(false); });
    }

    var RKEY = 'cdx_recent_searches';
    function getRecent() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) { return []; } }
    function saveRecent(term) {
      var arr = getRecent().filter(function (x) { return x !== term; });
      arr.unshift(term); arr = arr.slice(0, 5);
      try { localStorage.setItem(RKEY, JSON.stringify(arr)); } catch (e) {}
    }
    function renderRecent() {
      var box = mob ? mob.querySelector('[data-recent]') : null;
      if (!box) return;
      var arr = getRecent();
      box.closest('[data-recent-block]') && (box.closest('[data-recent-block]').hidden = arr.length === 0);
      box.innerHTML = arr.map(function (t) {
        return '<a href="' + (cfg.searchUrl || '/search') + '?q=' + encodeURIComponent(t) +
               '" class="cdx-hd__chip-rm">' + escapeHtml(t) + '</a>';
      }).join('');
    }
    function escapeHtml(s) { return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    var navRight = $('.cdx-hd__nav-right');
    var navInner = $('.cdx-hd__nav-inner');
    var navItems = $('.cdx-hd__nav-items');
    var mainInner = $('.cdx-hd__main-inner');
    var hdActions = $('.cdx-hd__actions');
    if (navRight && navInner && navItems && mainInner) {
      var moveNavRightUp = function () {
        if (navRight.parentNode !== mainInner) {
          if (hdActions && hdActions.parentNode === mainInner) mainInner.insertBefore(navRight, hdActions);
          else mainInner.appendChild(navRight);
        }
        root.classList.add('cdx-hd--nr-up');
      };
      var moveNavRightDown = function () {
        if (navRight.parentNode !== navInner) navInner.appendChild(navRight);
        root.classList.remove('cdx-hd--nr-up');
      };
      var recalcNavRight = function () {
        if (window.innerWidth < 1000) return;
        var avail = navInner.clientWidth;
        if (!avail) return;
        var itemsW = 0, i;
        for (i = 0; i < navItems.children.length; i++) itemsW += navItems.children[i].offsetWidth;
        var nrW = navRight.offsetWidth || 0;
        if (itemsW + nrW + 40 > avail) moveNavRightUp(); else moveNavRightDown();
      };
      recalcNavRight();
      window.addEventListener('load', recalcNavRight);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(recalcNavRight);
      var nrPending = false;
      window.addEventListener('resize', function () {
        if (nrPending) return;
        nrPending = true;
        requestAnimationFrame(function () { nrPending = false; recalcNavRight(); });
      });
    }

    var lockCount = 0;
    function lockBody(on) {
      lockCount = Math.max(0, lockCount + (on ? 1 : -1));
      document.documentElement.style.overflow = lockCount > 0 ? 'hidden' : '';
    }
  }

  /* Trusted-Shops-Widget: entscheidet genau einmal nach dem Rendern anhand von Breite/Hoehe,
     ob es Note und Bewertungszahl zeigt – misst dabei aber oft, bevor seine eigene CSS greift
     (die laedt es per @import, also asynchron). Bei kaltem Cache faellt es dadurch auf die
     kurze Variante ("4,87") zurueck und bleibt haengen, denn neu berechnet wird nur bei einem
     window-Resize. Ohne diesen Anstoss saehe der Header je nach Cache-Zustand anders aus –
     andere Anzeige und anderer Abstand zur rechten Kante. Zwei Zeitpunkte, damit auch langsame
     Verbindungen erwischt werden; ein zusaetzlicher Resize ist folgenlos.
     Kann entfallen, sobald Trusted Shops selbst einen ResizeObserver nutzt. */
  function nudgeEtrusted() {
    if (!document.querySelector('etrusted-widget')) return;
    var fire = function () { window.dispatchEvent(new Event('resize')); };
    setTimeout(fire, 500);
    setTimeout(fire, 2000);
  }
  if (document.readyState === 'complete') nudgeEtrusted();
  else window.addEventListener('load', nudgeEtrusted);

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.cdx-hd'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.cdx-hd') : null;
    if (el) { el.__cdxInit = false; init(el); }
  });
})();